import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationAdvantages = () => {
  const advantages = [
    {
      icon: 'MapPin',
      title: 'Altiplano Leste',
      description: 'Localização estratégica no coração do Altiplano Leste, com fácil acesso a todas as regiões de Brasília.'
    },
    {
      icon: 'Store',
      title: 'Comércio Próximo',
      description: 'Tenha acesso direto às lojas e serviços do Estação Marina, sem precisar sair do edifício.'
    },
    {
      icon: 'Car',
      title: 'Fácil Acesso',
      description: 'Próximo às principais vias de acesso, facilitando deslocamentos para trabalho e lazer.'
    },
    {
      icon: 'Utensils',
      title: 'Gastronomia',
      description: 'Diversos restaurantes e opções gastronômicas no próprio edifício e região.'
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            Localização Privilegiada
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Viva em um lugar que combina tranquilidade residencial com a 
            praticidade de ter tudo ao seu alcance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className="bg-card rounded-2xl p-6 border border-border shadow-warm hover:shadow-warm-lg transition-all duration-300 text-center"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-accent mb-4">
                <Icon name={advantage.icon} size={32} className="text-white" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                {advantage.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationAdvantages;
